import React from 'react';
import * as UI from '../../ui';
import { TitleTypes, TextTypes } from '../../ui';
import { FormattedMessage, useIntl } from 'react-intl';
import { TRuleWithTheme, useFelaEnhanced } from '@ackee/fela';
import * as felaRules from './ImageCard.rules';
import Img from './Img';
import type { ReferenceItemType } from '../CaseStudies/constants';

export type ImageCardProps = ReferenceItemType & { extend?: TRuleWithTheme; overlayColor?: string };

const { LazyLoadContainer, DynamicContainer, Text, Title } = UI;

const ImageCard = ({
    title,
    description,
    image,
    imagePixelated,
    link,
    extend,
    overlayColor,
    caseId, 
    profilePic,
    hideProfile
}: ImageCardProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <DynamicContainer extend={{ container: extend }}>
            <LazyLoadContainer lazyLoaded={false} animTimeout={200}>
                <DynamicContainer extend={{ container: rules.extendContainer }} columns={6}>
                    <UI.LocalizedLink to={link} className={styles.link}>
                        <div>
                            <div className="wrapper">
                                <div className={styles.imgWrapper}>
                                    {/* @ts-expect-error */}
                                    <Img
                                        className="pixelated"
                                        src={imagePixelated ?? image}
                                        alt={description}
                                        overlayColor={overlayColor}
                                        caseId={caseId}
                                        hideProfile={hideProfile}
                                        profilePic={profilePic}
                                    />
                                </div>
                            </div>
                            {/* @ts-expect-error */}
                            <Img src={image} alt={description} styles={styles} hideOverlayText />
                        </div>
                        {/* @ts-expect-error */}
                        <Title type={TitleTypes.H4} as={TitleTypes.H2} extend={{ title: rules.extendTitle }}>
                            <FormattedMessage id={title} />
                        </Title>
                        {/* @ts-expect-error */}
                        <Text type={TextTypes.LARGE} extend={{ text: rules.extendText }}>
                            <FormattedMessage id={description} />
                        </Text>
                    </UI.LocalizedLink>
                </DynamicContainer>
            </LazyLoadContainer>
        </DynamicContainer>
    );
};

export default ImageCard;
